




















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { imageUrl } from '@/shared/utils/images'
import { Hooks } from '@/shared/interfaces/hooks'

@Component
export default class RespondecoResponsiveImage extends Vue implements Hooks {
  @Prop({
    type: String,
  })
  public readonly alt?: string

  @Prop({
    type: Number,
  })
  public readonly height?: number

  @Prop({
    type: String,
  })
  public readonly image!: string

  @Prop({
    default: true,
    type: Boolean,
  })
  public readonly lazy!: boolean

  @Prop({
    type: [Number, Array],
  })
  public readonly width?: number | number[]

  public calculatedHeight!: number | undefined
  public calculatedSource!: string
  public calculatedSourceSet!: string
  public calculatedWidth: number | undefined

  public beforeDestroy(): void {
    window.removeEventListener('resize', this.resizeListener)
  }

  public beforeUpdate(): void {
    this.updateSizes()
  }

  public created() {
    this.updateSizes()
  }

  public mounted() {
    window.addEventListener('resize', this.resizeListener)

    this.$watch(
      () => this.image,
      () => {
        this.updateSizes()
      }
    )
  }

  public data(): any {
    return {
      calculatedHeight: undefined,
      calculatedSource: undefined,
      calculatedSourceSet: undefined,
      calculatedWidth: undefined,
    }
  }

  private calculateHeight(): number | undefined {
    let height: number | undefined

    if (Array.isArray(this.height)) {
      // For now support only xs and up
      if (window.innerWidth < 576) {
        height = this.height[0]
      } else {
        height = this.height[1]
      }
    } else {
      height = this.height
    }

    return height
  }

  private calculateSource(width?: number, height?: number): string {
    return imageUrl(this.image, width, height)
  }

  private calculateSourceSet(width?: number, height?: number): string {
    let sourceSetDefinition = ''

    if (width != null && height != null) {
      sourceSetDefinition = `
        ${imageUrl(this.image, width, height)},
        ${imageUrl(this.image, Math.floor(width * 1.5), Math.floor(height * 1.5))} 1.5x,
        ${imageUrl(this.image, width * 2, height * 2)} 2x
      `
    } else if (width != null) {
      sourceSetDefinition = `
        ${imageUrl(this.image, width)},
        ${imageUrl(this.image, Math.floor(width * 1.5))} 1.5x,
        ${imageUrl(this.image, width * 2)} 2x
      `
    } else if (height != null) {
      sourceSetDefinition = `
        ${imageUrl(this.image, undefined, height)},
        ${imageUrl(this.image, undefined, Math.floor(height * 1.5))} 1.5x,
        ${imageUrl(this.image, undefined, height * 2)} 2x
      `
    }

    return sourceSetDefinition
  }

  private calculateWidth(): number | undefined {
    let width: number | undefined

    if (Array.isArray(this.width)) {
      // For now support only xs and up
      if (window.innerWidth < 576) {
        width = this.width[0]
      } else {
        width = this.width[1]
      }
    } else {
      width = this.width
    }

    return width
  }

  private resizeListener = () => {
    this.updateSizes()
  }

  private updateSizes(): void {
    this.calculatedHeight = this.calculateHeight()
    this.calculatedWidth = this.calculateWidth()
    this.calculatedSource = this.calculateSource(this.calculatedWidth, this.calculatedHeight)
    this.calculatedSourceSet = this.calculateSourceSet(this.calculatedWidth, this.calculatedHeight)
  }
}
